import { render } from "./WisdomCare.vue?vue&type=template&id=492534b7"
import script from "./WisdomCare.vue?vue&type=script&lang=js"
export * from "./WisdomCare.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__